export enum StorageKeys {
  userId = 'userId',
  access_token = 'access_token',
  refresh_token = 'refresh_token',
  rememberMe = 'rememberMe'
}
